// Blog SEO — 11 articles longue traîne
export const BLOG_POSTS = [
  {
    slug: "jardin-juin-juillet-normandie-guide-2026",
    title: "Que faire au jardin en juin et juillet en Normandie ? Le guide saisonnier 2026",
    excerpt: "Tonte, taille, arrosage, traitements bio : les gestes essentiels pour un jardin normand éclatant en plein été.",
    cover: "https://images.unsplash.com/photo-1597201278257-3687be27d954?auto=format&fit=crop&w=1600&q=80",
    date: "2026-05-28",
    readTime: "9 min",
    category: "Saisonnier",
    keywords: ["jardin juin normandie", "jardin juillet normandie", "entretien jardin été", "que faire au jardin"],
    content: `En Normandie, juin et juillet sont les mois clés du jardin. La poussée est explosive, les hortensias se préparent à fleurir, les haies débordent et la pelouse demande une attention hebdomadaire. Voici votre guide saisonnier 2026 pour ne rien laisser au hasard dans le Calvados.

## Juin : le mois de la poussée maximale

### Tonte de pelouse : adaptez la hauteur
Sous le climat océanique du Calvados, l'herbe pousse vite. En juin, tondez **1 fois par semaine** avec une lame réglée à **5-6 cm de hauteur**. Une coupe trop courte favorise le dessèchement et les mousses. Préférez le **mulching** : les déchets fins fertilisent naturellement le sol et conservent l'humidité.

### Première taille de haie (avant la nidification… ou après)
La haie a explosé après le printemps. La taille de juin se fait **après le 1er juillet** dans l'idéal, pour respecter la fin de nidification des oiseaux (la LPO et la réglementation environnementale recommandent de ne pas tailler entre le 15 mars et le 31 juillet). Si vous devez tailler en juin, vérifiez visuellement l'absence de nid dans votre haie.

Taille en 3 faces (2 côtés + dessus), forme **légèrement trapézoïdale** (plus large en bas) pour que la lumière atteigne toute la haie.

### Désherbage et paillage des massifs
Profitez du sol encore humide pour désherber **manuellement** entre vos plantations. Puis **paillez** (BRF, paille, écorces) sur 5-7 cm pour limiter l'évaporation et empêcher les nouvelles repousses d'herbes folles.

### Surveillance des maladies fongiques
Le climat normand (chaleur + humidité) favorise oïdium, mildiou, taches noires du rosier. Inspectez régulièrement et traitez avec des produits biologiques autorisés (purin de prêle, savon noir, soufre). Évitez d'arroser le soir : l'humidité résiduelle nocturne favorise les champignons.

## Juillet : maintenir la beauté malgré la chaleur

### Arrosage stratégique
Arrosez **2 à 3 fois par semaine maximum**, mais en profondeur (15-20 minutes par zone). Les arrosages courts et fréquents créent des racines superficielles fragiles. Arrosez tôt le matin (6h-9h) ou le soir tardif pour limiter l'évaporation.

Les plantations de l'année (rosiers, arbustes, arbres) ont besoin de plus d'eau que les sujets établis : prévoyez un arrosage de secours pendant les vagues de chaleur.

### Taille des arbres fruitiers (cerisiers, pruniers)
Juillet est **la meilleure période** pour tailler les fruitiers à noyau, **juste après la récolte**. La taille en vert limite les écoulements de sève et permet de bien voir l'architecture de l'arbre. Supprimez les rejets, les branches mortes, et équilibrez la frondaison.

### Tonte plus haute en cas de sécheresse
Si juillet est sec (ce qui devient courant en Normandie), remontez la hauteur de tonte à **6-7 cm**. Une herbe plus haute fait de l'ombre au sol, limite l'évaporation et résiste mieux. Espacez les tontes (tous les 10-12 jours).

### Récolte du potager
Tomates, courgettes, haricots, salades : c'est l'apogée du potager normand. Pensez à pailler les pieds de tomates et à les tailler (gourmands) pour concentrer la sève vers les fruits.

## Les gestes à ne PAS oublier

### Taille d'entretien des massifs fleuris
Les rosiers remontants apprécient une petite taille post-floraison pour relancer une seconde vague de fleurs en août-septembre. Coupez les fleurs fanées (lavandes, hortensias, vivaces) pour stimuler une nouvelle floraison.

### Vérification de l'arrosage automatique
Si vous avez un système d'arrosage programmable, vérifiez les buses, les pressions et les horaires. C'est aussi le moment d'ajouter un capteur de pluie pour économiser l'eau.

## Quand faire appel à un professionnel ?

Juin et juillet sont des mois intenses. Si vous manquez de temps, voici ce que nos jardiniers prennent en charge dans le Calvados :
- **Passage hebdomadaire** : tonte, désherbage, taille légère
- **Taille complète des haies** (juin ou septembre)
- **Élagage de précision** pour préparer l'automne
- **Entretien complet du potager**

Les Jardiniers Normands proposent des contrats annuels modulables. Pour un particulier, l'entretien courant peut ouvrir droit, sous conditions, au crédit d'impôt service à la personne. Devis gratuit, intervention sous 24 h après acceptation.

## Conclusion

Un jardin normand de juin-juillet, c'est un équilibre entre activité (tonte, taille, arrosage) et observation (maladies, parasites, stress hydrique). Avec ces gestes simples, vous traversez l'été serein. Et si vous voulez profiter de votre jardin plutôt que de l'entretenir, on s'en occupe pour vous ☎ 07 80 04 43 90.`,
  },
  {
    slug: "quand-elaguer-arbre-calvados",
    title: "Quand élaguer un arbre dans le Calvados ? Le guide complet",
    excerpt: "Les meilleures périodes pour élaguer vos arbres en Normandie selon les essences, le climat normand et la réglementation.",
    cover: "https://images.unsplash.com/photo-1474742509976-ddec6b387356?auto=format&fit=crop&w=1600&q=80",
    date: "2025-03-15",
    readTime: "8 min",
    category: "Élagage",
    keywords: ["quand élaguer", "période élagage", "élagage normandie"],
    content: `L'élagage est une opération essentielle pour la santé, la sécurité et l'esthétique de vos arbres. Dans le Calvados, le climat océanique tempéré impose des règles spécifiques qu'il est crucial de respecter pour ne pas affaiblir l'arbre.

## Les périodes idéales pour élaguer en Normandie

### L'élagage en repos végétatif (novembre à mars)
La période hivernale, dite de repos végétatif, est la plus recommandée pour la plupart des essences présentes dans le Calvados : chênes, hêtres, frênes, érables. Pendant cette phase, la sève redescend, l'arbre cicatrise plus facilement et le risque de propagation de maladies est réduit.

Évitez cependant les périodes de gel intense (en dessous de -5°C) car le bois devient cassant et la cicatrisation est compromise.

### L'élagage en vert (juin à août)
Pour certaines essences comme les arbres fruitiers (cerisiers, pruniers), les bouleaux ou les érables, une taille en vert est préférable. Réalisée après la montée de sève, elle limite les écoulements et permet de mieux maîtriser la croissance.

## Espèces et calendrier dans le Calvados

- **Chênes et hêtres** : taille de novembre à février
- **Cerisiers et pruniers** : taille en juillet-août après récolte
- **Conifères (thuyas, cyprès)** : taille au printemps ou début automne
- **Bouleaux et érables** : taille en été pour limiter l'écoulement de sève
- **Tilleuls et platanes** : repos végétatif strict

## Pourquoi faire appel à un élagueur professionnel ?

Élaguer un arbre n'est pas un simple acte de jardinage. Cela demande :
- une **connaissance précise de la physiologie** de chaque essence ;
- un **équipement de sécurité** spécifique (cordes, harnais, tronçonneuse d'élagage) ;
- une **assurance responsabilité civile professionnelle** indispensable en cas d'accident ;
- le **respect de la réglementation** (PLU, distances voisinage, espèces protégées).

À Caen et dans tout le Calvados, **Pro Élagage 14** intervient avec une équipe de grimpeurs expérimentés, habitués à la taille raisonnée et à la sécurisation d'arbres en milieu urbain comme rural.

## Réglementation locale dans le Calvados

Le Code civil impose des distances de plantation et d'entretien :
- À **moins de 2 mètres** de la limite de propriété : hauteur maximale de **2 mètres**.
- À **plus de 2 mètres** : aucune limite de hauteur sauf règlement local.
- Le voisin peut exiger l'élagage des branches qui dépassent chez lui.

Certaines communes (Caen, Hérouville, Deauville) peuvent imposer des règles supplémentaires via leur PLU.

## Conclusion

L'élagage demande méthode, expérience et timing. Faire appel à un élagueur du Calvados garantit un travail conforme aux règles de l'art, sécurisé et respectueux de l'arbre. Demandez votre **devis gratuit** au 07 80 04 43 90.`,
  },
  {
    slug: "prix-paysagiste-caen",
    title: "Prix paysagiste à Caen : combien coûte un jardinier en 2025 ?",
    excerpt: "Guide des tarifs : entretien jardin, création paysagère, élagage. Conseils pour bien choisir.",
    cover: "https://images.unsplash.com/photo-1576897955702-24ad19680db3?auto=format&fit=crop&w=1600&q=80",
    date: "2025-03-08",
    readTime: "9 min",
    category: "Paysagisme",
    keywords: ["prix paysagiste caen", "tarif jardinier", "coût entretien jardin"],
    content: `Combien coûte un paysagiste à Caen en 2025 ? Voici un guide complet des tarifs pratiqués dans le Calvados, avec les facteurs qui influencent le prix et les aides disponibles.

## Tarifs moyens d'un paysagiste à Caen

### Entretien de jardin
- **Tonte de pelouse** : 25 à 45 €/heure
- **Taille de haie** : 35 à 55 €/heure (selon hauteur)
- **Désherbage et entretien massifs** : 30 à 45 €/heure
- **Contrat annuel d'entretien** : 80 à 250 €/mois selon surface

### Création paysagère
- **Conception de jardin** : 1 500 à 5 000 € pour un plan complet
- **Création complète clé en main** : à partir de **50 à 150 €/m²**
- **Plantation d'arbres** : 80 à 400 € pièce selon essence
- **Pose de gazon en rouleau** : 12 à 18 €/m²

### Élagage et abattage
- **Élagage d'un arbre moyen** : 200 à 600 €
- **Abattage classique** : 250 à 900 €
- **Abattage par démontage** : 600 à 2 500 €
- **Dessouchage** : 100 à 350 € par souche

## Crédit d'impôt : renseignez-vous

Les prestations d'**entretien courant de jardin** (tonte, taille de haie, débroussaillage) peuvent ouvrir droit, sous conditions, au **crédit d'impôt service à la personne** pour un particulier. Renseignez-vous sur votre situation et demandez-nous si votre intervention est concernée.

## Pourquoi nos tarifs sont compétitifs ?

Les Jardiniers Normands appliquent une **transparence totale** : devis gratuit détaillé, pas de frais cachés, paiement à la prestation. Nos équipes locales basées à Caen optimisent les déplacements et donc le coût final.

## Demandez votre devis gratuit

Chaque jardin est unique. Nos experts se déplacent gratuitement à Caen, Deauville, Lisieux, Falaise et partout dans le Calvados pour vous remettre un devis sur mesure. ☎ **07 80 04 43 90**.`,
  },
  {
    slug: "entretien-jardin-normandie-guide-saisonnier",
    title: "Entretien jardin Normandie : guide saisonnier complet",
    excerpt: "Que faire au jardin selon les saisons en Normandie ? Calendrier des travaux pour un extérieur impeccable toute l'année.",
    cover: "https://images.pexels.com/photos/3280078/pexels-photo-3280078.jpeg?auto=compress&cs=tinysrgb&w=1600",
    date: "2025-02-28",
    readTime: "10 min",
    category: "Entretien",
    keywords: ["entretien jardin normandie", "calendrier jardinage", "jardin calvados"],
    content: `Le climat normand, doux et humide, demande un entretien spécifique. Voici votre calendrier saisonnier pour un jardin éclatant dans le Calvados.

## Printemps (mars – mai) : le grand réveil

C'est la saison la plus active. Les plantations reprennent leur croissance, les sols se réchauffent.

- **Tonte** : reprise progressive, hauteur 5 à 7 cm en début, 4 à 5 cm ensuite
- **Scarification** de la pelouse pour éliminer mousse et feutre
- **Plantation** des vivaces, rosiers, arbustes
- **Taille des haies** de feuillus (avant la nidification)
- **Désherbage** et binage des massifs
- **Fertilisation** organique au printemps

## Été (juin – août) : entretien intensif

Le climat normand offre des étés doux mais humides, propices au développement des maladies fongiques.

- **Tonte hebdomadaire** (mulching conseillé)
- **Arrosage matinal** des plantations récentes
- **Taille en vert** des arbres fruitiers après récolte
- **Désherbage régulier** (paillage recommandé)
- **Surveillance maladies** (oïdium, mildiou)

## Automne (septembre – novembre) : préparation hivernale

L'automne normand est long et humide. C'est la saison clé pour préparer l'année suivante.

- **Ramassage des feuilles mortes** (compost)
- **Aération de la pelouse**, regarnissage
- **Plantation arbres et arbustes** (sol encore chaud)
- **Taille des haies persistantes**

## Hiver (décembre – février) : la saison des travaux structurels

- **Élagage des arbres** en repos végétatif
- **Abattage et dessouchage**
- **Taille des arbres fruitiers à pépins** (pommiers, poiriers)
- **Bêchage des massifs** par temps sec
- **Protection hivernale** des plantes fragiles

## Faites-vous accompagner

Un contrat annuel d'entretien jardin permet d'avoir un suivi régulier sans avoir à se soucier du calendrier. Les Jardiniers Normands proposent des **forfaits sur-mesure** dans tout le Calvados. Pour un particulier, l'entretien courant peut ouvrir droit, sous conditions, au crédit d'impôt service à la personne. ☎ 07 80 04 43 90.`,
  },
  {
    slug: "reglementation-abattage-arbre",
    title: "Réglementation abattage arbre : tout ce qu'il faut savoir",
    excerpt: "Autorisations, déclaration préalable, distances : la réglementation française sur l'abattage d'arbres expliquée simplement.",
    cover: "https://customer-assets.emergentagent.com/job_paysage-caen-seo/artifacts/8dqk3ati_abe%2035.jpg",
    date: "2025-02-05",
    readTime: "8 min",
    category: "Abattage",
    keywords: ["abattage arbre autorisation", "déclaration abattage", "réglementation arbre"],
    content: `Abattre un arbre n'est pas toujours libre. Voici les règles essentielles à connaître avant toute intervention dans le Calvados.

## Sur votre propre terrain : règles générales

Sur un terrain privé, hors zone protégée, **vous pouvez généralement abattre vos arbres**. Mais des exceptions existent :

### Cas où une autorisation est obligatoire :
- **Arbres en site classé ou inscrit** (autorisation préfectorale).
- **Arbres dans un Plan Local d'Urbanisme protégé** (déclaration en mairie).
- **Arbres remarquables** identifiés au PLU.
- **Espaces boisés classés (EBC)** : demande obligatoire.
- **Lotissements** : règlement de copropriété ou cahier des charges.

## En limite de propriété (Code civil)

- **Moins de 2m de la limite** : hauteur max 2m
- **Plus de 2m de la limite** : pas de limite légale (sauf PLU)
- Le voisin peut **exiger la coupe des branches** qui dépassent
- Les **fruits tombés** sur le terrain voisin lui appartiennent

## Espèces protégées

Certaines espèces (chênes pédonculés centenaires, ifs, etc.) peuvent bénéficier de protections locales. Renseignez-vous toujours en mairie.

## Que risquez-vous en cas d'abattage illégal ?

- **Amende** jusqu'à 1 500 €
- **Obligation de replantation**
- **Poursuites pénales** en cas de destruction d'espèce protégée

## Notre conseil

Avant toute coupe importante, **consultez votre mairie** ou faites appel à un professionnel local qui connaît les règles spécifiques.

**Pro Élagage 14** intervient dans tout le Calvados en respect strict de la réglementation, avec assurance responsabilité civile professionnelle. ☎ 07 80 04 43 90.`,
  },
  {
    slug: "entretien-pelouse-caen",
    title: "Entretien pelouse à Caen : 10 conseils d'expert pour un gazon parfait",
    excerpt: "Tonte, fertilisation, scarification, arrosage : tous les secrets d'une pelouse impeccable en Normandie.",
    cover: "https://images.pexels.com/photos/32500250/pexels-photo-32500250.jpeg?auto=compress&cs=tinysrgb&w=1600",
    date: "2025-01-28",
    readTime: "9 min",
    category: "Entretien",
    keywords: ["entretien pelouse", "tonte gazon", "pelouse caen"],
    content: `Une pelouse normande dense et verte exige des gestes réguliers et adaptés au climat océanique. Voici les 10 conseils incontournables.

## 1. Adaptez la hauteur de tonte aux saisons
- Printemps : 5 cm puis 4 cm
- Été : 5 à 6 cm (résistance à la sécheresse)
- Automne : 4 cm puis remontez à 5 cm avant l'hiver

## 2. Tondez régulièrement
1 fois/semaine en pleine poussée, jamais plus d'1/3 de la hauteur.

## 3. Pratiquez le mulching
Les déchets de tonte fertilisent naturellement le sol et limitent l'évaporation.

## 4. Scarifiez 2 fois par an
Mars et septembre : éliminez mousse et feutre pour aérer le sol.

## 5. Fertilisez intelligemment
Engrais riche en azote au printemps, engrais d'automne riche en potassium en septembre.

## 6. Aérez votre sol
Une fois par an avec une fourche-bêche ou un aérateur mécanique.

## 7. Arrosez profondément
Plutôt que de petits arrosages, privilégiez un arrosage long 2 fois/semaine en été.

## 8. Regarnissez les zones dénudées
À l'automne, semez du gazon résistant à la mousse, idéal en Normandie.

## 9. Désherbage sélectif
Éliminez mauvaises herbes à la main ou avec un désherbant sélectif.

## 10. Confiez l'entretien à un pro
Un contrat d'entretien annuel garantit la régularité et le savoir-faire. Pour un particulier, l'entretien courant peut ouvrir droit, sous conditions, au crédit d'impôt service à la personne.

Les Jardiniers Normands entretiennent les pelouses dans tout le Calvados ☎ 07 80 04 43 90.`,
  },
  {
    slug: "creation-jardin-paysager",
    title: "Création de jardin paysager : les étapes d'un projet réussi",
    excerpt: "De l'esquisse à la livraison : comment se déroule la création d'un jardin paysager sur mesure.",
    cover: "https://images.unsplash.com/photo-1597201278257-3687be27d954?auto=format&fit=crop&w=1600&q=80",
    date: "2025-01-15",
    readTime: "8 min",
    category: "Paysagisme",
    keywords: ["création jardin", "paysagiste calvados", "aménagement extérieur"],
    content: `Créer un jardin de A à Z est un projet excitant mais exigeant. Voici les étapes pour réussir votre aménagement paysager.

## Étape 1 : analyse du terrain
Étude du sol (pH, drainage), exposition, vents dominants, contraintes (PLU, mitoyenneté).

## Étape 2 : définition des besoins
Espace détente ? Potager ? Aire de jeux pour enfants ? Piscine ? Chaque usage influence le plan.

## Étape 3 : esquisse paysagère
Notre paysagiste réalise un plan 2D ou 3D avec les zones, circulations, plantations.

## Étape 4 : préparation du sol
Décompactage, apport de terre végétale, drainage si nécessaire.

## Étape 5 : structure végétale
Implantation des haies, massifs et arbres, paillage, arrosage.

## Étape 6 : plantations
Choix des essences adaptées au climat normand : hortensias, érables, graminées, vivaces locales.

## Étape 7 : engazonnement
Gazon semé ou en rouleau selon délai et budget.

## Étape 8 : entretien la 1ère année
Suivi des plantations, arrosage, fertilisation, taille de formation.

## Budget moyen
Un jardin clé en main coûte entre **50 et 150 €/m²** selon les prestations choisies. Notre devis est toujours gratuit.

Les Jardiniers Normands créent des jardins sur-mesure dans tout le Calvados ☎ 07 80 04 43 90.`,
  },
  {
    slug: "taille-de-haie-quand-comment",
    title: "Taille de haie : quand et comment procéder ?",
    excerpt: "Périodes idéales, techniques, matériel, réglementation : le guide complet pour une haie impeccable.",
    cover: "https://customer-assets.emergentagent.com/job_paysage-caen-seo/artifacts/9x11h3nx_abe%2025.jpg",
    date: "2025-01-08",
    readTime: "7 min",
    category: "Entretien",
    keywords: ["taille haie", "quand tailler haie", "entretien haie"],
    content: `Une haie bien taillée structure le jardin, protège du vent et préserve l'intimité. Voici quand et comment intervenir.

## Périodes de taille

### Haies de feuillus (charme, hêtre, érable)
- **1ère taille** : fin juin (après nidification)
- **2ème taille** : septembre-octobre

### Haies de persistants (thuya, laurier, cyprès)
- **Mars-avril** puis **septembre**

### Haies fleuries (forsythia, weigela)
- **Juste après la floraison**

## Période interdite

**Du 15 mars au 31 juillet**, la LPO et la réglementation environnementale **déconseillent fortement** la taille pour protéger les oiseaux nicheurs. Une taille de printemps doit donc être réalisée avant le 15 mars ou en juin.

## Techniques

### Taille d'entretien
- Sur **3 faces** : 2 côtés + dessus
- Forme **légèrement trapézoïdale** (plus large en bas) pour la lumière
- Coupe nette pour cicatrisation rapide

### Taille de rajeunissement
- Pour haies très anciennes ou dégarnies
- Coupe sévère, à réaliser en hiver
- Risque de mortalité sur certaines essences (cyprès)

## Matériel
- Taille-haie thermique pour grandes longueurs
- Sécateur ou cisaille pour les finitions
- Échafaudage ou échelle stable pour haies hautes
- Lunettes, gants, casque

## Évacuation des déchets
Souvent oubliée, l'évacuation représente 20 à 30% du temps total. Nos équipes l'incluent toujours dans nos devis.

Les Jardiniers Normands taillent vos haies dans tout le Calvados ☎ 07 80 04 43 90.`,
  },
  {
    slug: "conseils-paysagiste-normand",
    title: "10 conseils d'un paysagiste normand pour un jardin durable",
    excerpt: "Plantes locales, gestion de l'eau, biodiversité : les meilleures pratiques pour un jardin écologique en Normandie.",
    cover: "https://images.unsplash.com/photo-1576897955702-24ad19680db3?auto=format&fit=crop&w=1600&q=80",
    date: "2024-12-10",
    readTime: "10 min",
    category: "Paysagisme",
    keywords: ["paysagiste normandie", "jardin durable", "plantes locales"],
    content: `Un jardin normand durable c'est un jardin qui respecte le climat, la faune locale et limite son empreinte. Voici 10 conseils.

## 1. Privilégiez les essences locales
Hortensias, érables champêtres, pommiers, viornes, prunelliers : elles sont adaptées au climat.

## 2. Plantez des haies champêtres
Au lieu du thuya, optez pour un mix de noisetiers, charmes, sureaux : biodiversité +++.

## 3. Limitez la pelouse
Remplacez une partie par des prairies fleuries ou des couvre-sols (pervenche, lierre terrestre).

## 4. Récupérez l'eau de pluie
1m² de toit = 0,8L d'eau par millimètre de pluie. Énorme potentiel en Normandie.

## 5. Compostez vos déchets verts
Tonte, feuilles, tailles → compost en 6 mois.

## 6. Paillez vos massifs
Limite l'évaporation et le désherbage. BRF, paille, écorces de pin.

## 7. Favorisez les insectes pollinisateurs
Lavandes, sauges, sedums, asters : nectar abondant.

## 8. Créez un coin sauvage
Tas de bois, mare, herbe haute : refuge pour hérissons, oiseaux, batraciens.

## 9. Évitez les produits chimiques
Interdits aux particuliers depuis 2019. Alternatives : purins, savons noirs, traitements bio.

## 10. Faites-vous accompagner
Un paysagiste local connaît les particularités du Calvados et vous fait gagner du temps.

Les Jardiniers Normands conçoivent des jardins durables et adaptés à la Normandie ☎ 07 80 04 43 90.`,
  },
  {
    slug: "dessouchage-methodes-tarifs",
    title: "Dessouchage : méthodes, tarifs et conseils pour un terrain propre",
    excerpt: "Rognage, dessouchage chimique, manuel : quelle méthode choisir pour éliminer une souche d'arbre ?",
    cover: "https://customer-assets.emergentagent.com/job_paysage-caen-seo/artifacts/8dqk3ati_abe%2035.jpg",
    date: "2024-11-25",
    readTime: "6 min",
    category: "Élagage",
    keywords: ["dessouchage", "enlèvement souche", "rognage souche"],
    content: `Après l'abattage d'un arbre, la souche reste. Voici comment l'éliminer proprement.

## Pourquoi enlever une souche ?

- **Esthétique** : terrain dégagé
- **Sécurité** : pas de trébuchement
- **Phytosanitaire** : évite parasites et champignons
- **Replantation** : terrain prêt pour nouveau projet
- **Aménagement** : plantations, massifs, pelouse

## Les méthodes de dessouchage

### Rognage (méthode pro recommandée)
Une rogneuse mécanique broie la souche jusqu'à 30 cm sous la surface.
- **Rapide** (30 min à 2h selon taille)
- **Propre** (copeaux récupérables ou laissés)
- **Sans dégât** au terrain
- **Tarif** : 100 à 350 €/souche

### Extraction mécanique
Une mini-pelle déterre la souche entière.
- Adapté aux grosses souches
- Trace importante à reboucher
- Tarif : 250 à 600 €

### Dessouchage chimique
Application d'un produit accélérant la décomposition.
- Long (6 mois à 2 ans)
- Peu utilisé par les pros (impact environnemental)

### Dessouchage manuel
À la hache et au pic. Réservé aux petites souches.
- Très laborieux
- Risque de blessure

## Notre recommandation

Le **rognage mécanique** est la solution la plus propre, rapide et économique. Pro Élagage 14 dispose du matériel nécessaire pour intervenir partout dans le Calvados.

Devis gratuit ☎ 07 80 04 43 90.`,
  },
  {
    slug: "pourquoi-elagueur-professionnel",
    title: "Pourquoi faire appel à un élagueur professionnel ? 7 raisons",
    excerpt: "Sécurité, expertise, assurance : les 7 raisons impératives de confier votre élagage à un pro expérimenté.",
    cover: "https://images.unsplash.com/photo-1762903938137-49b0a145e241?auto=format&fit=crop&w=1600&q=80",
    date: "2024-11-12",
    readTime: "7 min",
    category: "Élagage",
    keywords: ["élagueur professionnel", "pourquoi élagueur", "élagueur professionnel"],
    content: `Élaguer soi-même un arbre semble simple. C'est en réalité l'une des activités les plus dangereuses au jardin. Voici pourquoi un pro est indispensable.

## 1. La sécurité avant tout
L'élagage est la **1ère cause d'accidents domestiques graves** liés au jardinage. Chutes, coupures à la tronçonneuse, électrocution : les risques sont multiples.

## 2. L'expertise technique
Chaque essence demande une **taille spécifique** :
- Taille douce ou raisonnée
- Taille architecturée
- Taille de formation
- Taille sanitaire
Un pro adapte sa coupe pour préserver la santé de l'arbre.

## 3. L'équipement professionnel
- Cordes statiques et dynamiques
- Harnais d'élagage aux normes EN
- Tronçonneuse d'élagage
- Casque, lunettes, jambières anti-coupure
Investissement total : **5 000 à 10 000 €**.

## 4. L'assurance responsabilité civile
Indispensable en cas de dégât (toit voisin, ligne électrique, voiture). Un particulier n'est généralement pas couvert pour ce type de travaux.

## 5. La gestion des déchets
Évacuation, broyage, recyclage : un pro inclut généralement tout dans son devis.

## 6. La conformité réglementaire
Connaissance du PLU, des espèces protégées, des distances légales.

## 7. La garantie résultat
Travail propre, à la date prévue, avec engagement de qualité.

## Comment choisir son élagueur ?

- Expérience et références à vérifier
- Assurance RC pro (à demander)
- Devis détaillé et gratuit
- Avis Google à consulter
- Local et joignable

**Pro Élagage 14** répond à chacun de ces points dans le Calvados ☎ 07 80 04 43 90.`,
  },
];

export const getPost = (slug) => BLOG_POSTS.find((p) => p.slug === slug);
